import React, { useState, useEffect } from "react";
import "./style.css";
import { Row, Col } from "antd";
import Logo999 from "../../image/Pipa Freightliner 20000LT (3).jpg";
import pipa_upv from "../../image/pipa_upv.png";
import Logo8889 from "../../image/Pipa 30,000 lt.jpg";

import Footer from "../FooterComponent";
import { useDispatch } from "react-redux";
import { updateProductsState } from "../../store/profile";
import NavbarComponent from "../NavbarComponent";
import { useSelector } from "react-redux";

import { checkCartIfExist } from "../../helper";
import { LoadingOutlined } from "@ant-design/icons";

function SixteenSection() {
  const dispatch = useDispatch();
  const { products } = useSelector((state) => state.profile);

  const [loading, setloading] = useState(false);
  const [hitUseEffect, sethitUseEffect] = useState(false);

  const handleLoading = () => {
    setloading(false);
  };

  useEffect(() => {
    setloading(true);

    setTimeout(handleLoading, 1000);
  }, [hitUseEffect, products]);
  return (
    <>
      <NavbarComponent />
      <div>
        <div className="border">
          <Row className="rowo1" justify="space-between">
            <Col lg={12} md={24} xs={24}>
              <div>
                <img className="bus img-fluid" src={Logo999} alt="" />
              </div>
            </Col>
            <Col lg={9} md={24} xs={24}>
              <div className="divohol">
                <div className="divo">
                  <h6 className="dd13">FREIGHTLINER</h6>
                </div>
                <div className="potenhol">
                  <div>
                    <h6 className="poten">Motor</h6>
                  </div>
                  <div className="power">
                    <h6 className="poten">322 HP</h6>
                  </div>
                </div>
                <div className="potenhol1">
                  <div className="gray">
                    <h6 className="carga">Capacidad</h6>
                  </div>
                  <div className="gray1">
                    <h6 className="poten">20,000 LT</h6>
                  </div>
                </div>
                <div className="potenhol">
                  <div>
                    <h6 className="poten">Capacidad de carga eje delantero</h6>
                  </div>
                  <div className="power">
                    <h6 className="poten">14,600 LB</h6>
                  </div>
                </div>
                <div className="potenhol1">
                  <div className="gray">
                    <h6 className="carga">Capacidad de carga eje traser</h6>
                  </div>
                  <div className="gray1">
                    <h6 className="poten">46,000 LB</h6>
                  </div>
                </div>
                <div className="potenhol">
                  <div>
                    <h6 className="poten">UNIDADES DISPONIBLES</h6>
                  </div>
                  <div className="power1">
                    <h6 className="poten">5</h6>
                  </div>
                </div>
                <div className="btonmng">
                  <div>
                    <button className="btonficha">
                      <h6 className="ficha">FICHA TECNICA</h6>
                    </button>
                  </div>
                  <div>
                    {loading ? (
                      <LoadingOutlined />
                    ) : (
                      <>
                        {checkCartIfExist("FORD P2") ? (
                          <p style={{ color: "green" }}>Added!</p>
                        ) : (
                          <button
                            className="btonficha1"
                            onClick={() => {
                              dispatch(
                                updateProductsState({
                                  class: "Pipas",
                                  name: "FORD P2",
                                  motor: "322 HP",
                                  canacidad_de_carna_pie_delantero: "14,600 LB",
                                  capacidad_de_carga_eje_trasero: "46,000 LB",
                                  capacidad: "20,000 LT",
                                  unidades_disponibles: "5",
                                })
                              );

                              setloading(true);
                              sethitUseEffect(!hitUseEffect);
                            }}
                          >
                            <h6 className="ficha">AÑADIR A COTIZACIÓN</h6>
                          </button>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="rowo1" justify="space-between">
            <Col lg={12} md={24} xs={24}>
              <div>
                <img className="bus img-fluid" src={Logo8889} alt="" />
              </div>
            </Col>
            <Col lg={9} md={24} xs={24}>
              <div className="divohol">
                <div className="divo">
                  <h6 className="dd13">FREIGHTLINER</h6>
                </div>
                <div className="potenhol">
                  <div>
                    <h6 className="poten">Motor</h6>
                  </div>
                  <div className="power">
                    <h6 className="poten">322 HP</h6>
                  </div>
                </div>
                <div className="potenhol1">
                  <div className="gray">
                    <h6 className="carga">Capacidad</h6>
                  </div>
                  <div className="gray1">
                    <h6 className="poten">30,000 LT</h6>
                  </div>
                </div>
                <div className="potenhol">
                  <div>
                    <h6 className="poten">Capacidad de carga eje delantero</h6>
                  </div>
                  <div className="power">
                    <h6 className="poten">14,600 LB</h6>
                  </div>
                </div>
                <div className="potenhol1">
                  <div className="gray">
                    <h6 className="carga">Capacidad de carga eje traser</h6>
                  </div>
                  <div className="gray1">
                    <h6 className="poten">46,000 LB</h6>
                  </div>
                </div>
                <div className="potenhol">
                  <div>
                    <h6 className="poten">UNIDADES DISPONIBLES</h6>
                  </div>
                  <div className="power1">
                    <h6 className="poten">2</h6>
                  </div>
                </div>
                <div className="btonmng">
                  <div>
                    <button className="btonficha">
                      <h6 className="ficha">FICHA TECNICA</h6>
                    </button>
                  </div>
                  <div>
                    {loading ? (
                      <LoadingOutlined />
                    ) : (
                      <>
                        {checkCartIfExist("FORD P3 PIPAS") ? (
                          <p style={{ color: "green" }}>Added!</p>
                        ) : (
                          <button
                            className="btonficha1"
                            onClick={() => {
                              dispatch(
                                updateProductsState({
                                  class: "Pipas",
                                  name: "FORD P3 PIPAS",
                                  motor: "322 HP",
                                  canacidad_de_carna_pie_delantero: "14,600 LB",
                                  capacidad_de_carga_eje_trasero: "46,000 LB",
                                  capacidad: "30,000 LT",
                                  unidades_disponibles: "2",
                                })
                              );

                              setloading(true);
                              sethitUseEffect(!hitUseEffect);
                            }}
                          >
                            <h6 className="ficha">AÑADIR A COTIZACIÓN</h6>
                          </button>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="rowo1" justify="space-between">
            <Col lg={12} md={24} xs={24}>
              <div>
                <img className="bus img-fluid" src={pipa_upv} alt="" />
              </div>
            </Col>
            <Col lg={9} md={24} xs={24}>
              <div className="divohol">
                <div className="divo">
                  <h6 className="dd13">PIPA TANQUE UPV</h6>
                </div>
                <div className="potenhol1">
                  <div className="gray">
                    <h6 className="carga">Capacidad</h6>
                  </div>
                  <div className="gray1">
                    <h6 className="poten">30,000 LT</h6>
                  </div>
                </div>
                <div className="btonmng">
                  <div>
                  </div>
                  <div>
                    {loading ? (
                      <LoadingOutlined />
                    ) : (
                      <>
                        {checkCartIfExist("PIPA TANQUE UPV") ? (
                          <p style={{ color: "green" }}>Added!</p>
                        ) : (
                          <button
                            className="btonficha1"
                            onClick={() => {
                              dispatch(
                                updateProductsState({
                                  class: "Pipas",
                                  name: "PIPA TANQUE UPV",
                                  capacidad: "30,000 LT",
                                  unidades_disponibles: "1",
                                })
                              );

                              setloading(true);
                              sethitUseEffect(!hitUseEffect);
                            }}
                          >
                            <h6 className="ficha">AÑADIR A COTIZACIÓN</h6>
                          </button>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default SixteenSection;
